// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils__Bool from "@pageblocks/utils/src/bool/Utils__Bool.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Ui__Feedback from "../feedback/Ui__Feedback.bs.js";
import * as ReactNative from "react-native";
import * as Style$ReactNative from "rescript-react-native/src/apis/Style.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils__SimpleReact from "@pageblocks/utils/src/simpleReact/Utils__SimpleReact.bs.js";

function fromRN(param) {
  return {
          pressed: param.pressed,
          focused: Core__Option.getOr(param.focused, false),
          hovered: Core__Option.getOr(param.hovered, false)
        };
}

var InteractionState = {
  fromRN: fromRN
};

function Ui__Box$ControlledView(props) {
  var onHover = props.onHover;
  var match = React.useState(function () {
        return false;
      });
  var setHovered = match[1];
  var hovered = match[0];
  return JsxRuntime.jsx(ReactNative.View, {
              accessibilityElementsHidden: props.accessibilityElementsHidden,
              accessibilityHint: props.accessibilityHint,
              accessibilityIgnoresInvertColors: props.accessibilityIgnoresInvertColors,
              accessibilityLabel: props.accessibilityLabel,
              accessibilityLiveRegion: props.accessibilityLiveRegion,
              accessibilityRole: props.accessibilityRole,
              accessibilityState: props.accessibilityState,
              accessibilityValue: props.accessibilityValue,
              accessibilityViewIsModal: props.accessibilityViewIsModal,
              accessible: props.accessible,
              hitSlop: props.hitSlop,
              importantForAccessibility: props.importantForAccessibility,
              onLayout: props.onLayout,
              style: Core__Option.map(props.style, (function (style) {
                      return style({
                                  pressed: false,
                                  focused: false,
                                  hovered: hovered
                                });
                    })),
              testID: props.testID,
              children: Caml_option.some(Utils__SimpleReact.renderIfSome(props.children, (function (children) {
                          return children({
                                      pressed: false,
                                      focused: false,
                                      hovered: hovered
                                    });
                        }))),
              href: props.href,
              hrefAttrs: props.hrefAttrs,
              onMouseEnter: Core__Option.map(onHover, (function (onHover) {
                      return function (param) {
                        setHovered(function (param) {
                              return true;
                            });
                        onHover();
                      };
                    })),
              onMouseLeave: Core__Option.map(onHover, (function (param) {
                      return function (_event) {
                        setHovered(function (param) {
                              return false;
                            });
                      };
                    }))
            });
}

var PressableProps = {};

function Ui__Box(props) {
  var updateChildProps = props.updateChildProps;
  var hrefAttrs = props.hrefAttrs;
  var href = props.href;
  var accessibilityViewIsModal = props.accessibilityViewIsModal;
  var accessibilityValue = props.accessibilityValue;
  var accessibilityState = props.accessibilityState;
  var accessibilityRole = props.accessibilityRole;
  var accessibilityLiveRegion = props.accessibilityLiveRegion;
  var accessibilityLabel = props.accessibilityLabel;
  var accessibilityIgnoresInvertColors = props.accessibilityIgnoresInvertColors;
  var accessibilityHint = props.accessibilityHint;
  var accessibilityElementsHidden = props.accessibilityElementsHidden;
  var accessible = props.accessible;
  var importantForAccessibility = props.importantForAccessibility;
  var testID = props.testID;
  var hitSlop = props.hitSlop;
  var onLayout = props.onLayout;
  var style = props.style;
  var children = props.children;
  var onHover = props.onHover;
  var __kind = props.kind;
  var kind = __kind !== undefined ? __kind : "NonPressable";
  if (typeof kind !== "object") {
    return JsxRuntime.jsx(Ui__Box$ControlledView, {
                onHover: onHover,
                children: children,
                style: style,
                onLayout: onLayout,
                hitSlop: hitSlop,
                testID: testID,
                importantForAccessibility: importantForAccessibility,
                accessible: accessible,
                accessibilityElementsHidden: accessibilityElementsHidden,
                accessibilityHint: accessibilityHint,
                accessibilityIgnoresInvertColors: accessibilityIgnoresInvertColors,
                accessibilityLabel: accessibilityLabel,
                accessibilityLiveRegion: accessibilityLiveRegion,
                accessibilityRole: accessibilityRole,
                accessibilityState: accessibilityState,
                accessibilityValue: accessibilityValue,
                accessibilityViewIsModal: accessibilityViewIsModal,
                href: href,
                hrefAttrs: hrefAttrs
              });
  }
  var match = kind.VAL;
  var feedback = match.feedback;
  var match$1 = Core__Option.map(feedback, Ui__Feedback.toVariant);
  var tmp = {};
  var tmp$1 = match$1 !== undefined && match$1.NAME === "Opacity" ? match$1.VAL : undefined;
  if (tmp$1 !== undefined) {
    tmp.opacity = tmp$1;
  }
  var opacityStyle = tmp;
  return JsxRuntime.jsx(ReactNative.Pressable, {
              accessibilityElementsHidden: accessibilityElementsHidden,
              accessibilityHint: accessibilityHint,
              accessibilityIgnoresInvertColors: accessibilityIgnoresInvertColors,
              accessibilityLabel: accessibilityLabel,
              accessibilityLiveRegion: accessibilityLiveRegion,
              accessibilityRole: accessibilityRole,
              accessibilityState: accessibilityState,
              accessibilityValue: accessibilityValue,
              accessibilityViewIsModal: accessibilityViewIsModal,
              accessible: accessible,
              importantForAccessibility: importantForAccessibility,
              children: Core__Option.getOr(Core__Option.map(children, (function (children) {
                          return function (interactionState) {
                            var match = Core__Option.map(feedback, Ui__Feedback.toVariant);
                            if (match === undefined) {
                              return children(fromRN(interactionState));
                            }
                            if (match.NAME === "Opacity") {
                              return children(fromRN(interactionState));
                            }
                            var match$1 = match.VAL;
                            var opacity = match$1.opacity;
                            var backgroundColor = match$1.backgroundColor;
                            return [
                                    Utils__SimpleReact.whenTrue(interactionState.pressed, {
                                          LAZY_DONE: false,
                                          VAL: (function () {
                                              return JsxRuntime.jsx(ReactNative.View, {
                                                          pointerEvents: "none",
                                                          style: [
                                                            {
                                                              height: Style$ReactNative.pct(100),
                                                              position: "absolute",
                                                              right: 0,
                                                              top: 0,
                                                              width: Style$ReactNative.pct(100),
                                                              zIndex: -1
                                                            },
                                                            {
                                                              backgroundColor: backgroundColor
                                                            }
                                                          ]
                                                        }, "HighlightElement");
                                            })
                                        }),
                                    React.Children.map(children(fromRN(interactionState)), (function (child) {
                                            var props = Core__Option.getOr(child.props, JSON.parse("{}"));
                                            var childStyle = child.props.style;
                                            return React.cloneElement(child, updateChildProps !== undefined ? updateChildProps(props, fromRN(interactionState), opacity) : Object.fromEntries([[
                                                                "style",
                                                                [
                                                                  childStyle,
                                                                  Utils__Bool.thenSome(interactionState.pressed, {
                                                                        LAZY_DONE: false,
                                                                        VAL: (function () {
                                                                            return {
                                                                                    opacity: opacity
                                                                                  };
                                                                          })
                                                                      })
                                                                ]
                                                              ]]));
                                          }))
                                  ];
                          };
                        })), (function (param) {
                      return null;
                    })),
              delayLongPress: match.delayLongPress,
              disabled: match.disabled,
              hitSlop: hitSlop,
              onLayout: onLayout,
              onLongPress: match.onLongPress,
              onPress: match.onPress,
              onPressIn: match.onPressIn,
              onPressOut: match.onPressOut,
              style: (function (interactionState) {
                  return [
                          Utils__Bool.thenSome(interactionState.pressed, {
                                LAZY_DONE: true,
                                VAL: opacityStyle
                              }),
                          Core__Option.map(style, (function (makeStyle) {
                                  return makeStyle(fromRN(interactionState));
                                }))
                        ];
                }),
              testID: testID,
              href: href,
              hrefAttrs: hrefAttrs,
              onHoverIn: Core__Option.map(onHover, (function (onHover) {
                      return function (_event) {
                        onHover();
                      };
                    }))
            });
}

function castToJson(prim) {
  return prim;
}

var make = Ui__Box;

export {
  InteractionState ,
  castToJson ,
  PressableProps ,
  make ,
}
/* react Not a pure module */
